/**
 * JustRelate CRM Web Client
 * Copyright (c) 2021 - 2025 JustRelate Deutschland GmbH
 */

import PISA_WebClientInit from './init';

// call global initialization function
PISA_WebClientInit();

// End Of File //
